export default {
  data() {
    return {
      tableHeight: 0,
      scrollToptimer: null,
      listLoading: true
    }
  },
  mounted() {
    if (document.getElementById('baseTable')) {
      window.addEventListener('resize', this.getTableHeight)
      this.getTableHeight()
    }
    setTimeout(() => {
      if (document.getElementById('baseTable')) {
        window.addEventListener('resize', this.getTableHeight)
        this.getTableHeight()
      }
    }, 600)
  },
  destroyed() {
    window.removeEventListener('resize', this.getTableHeight)
    if (this.scrollToptimer) {
      clearInterval(this.this.scrollToptimer)
    }
  },
  methods: {
    resetScroll() {
      let scrollDom = document.getElementById('baseTable').getElementsByClassName('el-table__body-wrapper')[0]
      scrollDom.scrollTop = 0
      scrollDom.scrollLeft = 0
      // this.scrollToptimer = setInterval(() => {
      //   var top = scrollDom.scrollTop
      //   var left = scrollDom.scrollLeft
      //   var speedTop = top / 4
      //   var speedLeft = left / 4
      //   scrollDom.scrollTop -= speedTop
      //   scrollDom.scrollLeft -= speedLeft
      //   if (speedTop == 0 && speedLeft == 0) {
      //     clearInterval(this.scrollToptimer)
      //     this.scrollToptimer = null
      //   }
      // }, 30)
    },
    getTableHeight() {
      var rect = document.getElementById('baseTable').getBoundingClientRect()
      this.$nextTick(() => {
        this.tableHeight = window.innerHeight - rect.top - 130
      })
    }
  }
}
